export default __webpack_public_path__ + "static/media/hairCut.4b67c684.jpg";